import { apiGetIngredientInfo } from "Root/api/apiCheckout";
const getAllIngredients = ({ cart, setIngredients, setName, name, setUserName }) => {
    const tempIngredients = {
        boosts: {
            name: "",
            ingredients: [],
            nutrition_facts: {},
            product_title: "your perfomance boosts",
            product_key: "boosts",
            macros: [],
            key_benefits: []
        },
    };
    Object.keys(cart).forEach((item) => {
        if (!cart[item] || item === "null")
            return;
        const getIngredientInfo = async (key) => {
            const data = await apiGetIngredientInfo(key);
            if (data) {
                if (item === "collagen" || item === "creatine" || item === "fiber") {
                    tempIngredients.boosts.name = data[0].name;
                    tempIngredients.boosts.nutrition_facts = {
                        ...tempIngredients.boosts.nutrition_facts,
                        [item]: data[0].nutrition_facts,
                    };
                    tempIngredients.boosts.ingredients = [...tempIngredients.boosts.ingredients, ...data[0].ingredients];
                }
                else {
                    [tempIngredients[item]] = data;
                }
                if (!name && data.length > 0) {
                    setName(data[0].name);
                    setUserName(data[0].name);
                }
                setIngredients({ ...tempIngredients });
            }
        };
        getIngredientInfo(item);
    });
};
export default getAllIngredients;
